import React from 'react';
import { DashboardTemplate } from './shared';
import { homeConfig, mockHomeData } from './configs/home-config';
import { mergeDataWithFallback } from '../../../utils/dataFallback';

function HomeData({ report = {}, loading = false }) {
    // Only use mock data when not loading (to avoid showing mock data before API response)
    const dataWithMock = loading ? report : mergeDataWithFallback(report, mockHomeData);
    
    return (
        <DashboardTemplate 
            title={homeConfig.title}
            topKPIs={homeConfig.topKPIs}
            charts={homeConfig.charts}
            bottomKPIs={homeConfig.bottomKPIs}
            bottomTitle={homeConfig.bottomTitle}
            report={dataWithMock}
            loading={loading}
        />
    );
}

export default HomeData;